<template>
  <div id="app">
    <Header></Header>
    <router-view/>
  </div>
</template>


<script>
import Header from "./components/Header/Header"
export default {
  name: 'App',
  components:{
    Header
  }
}

</script>

<style>
li{ list-style: none;}
*{padding: 0px;margin: 0px;}
a{text-decoration: none;}
a:hover{text-decoration:underline;}
</style>



// WEBPACK FOOTER //
// src/App.vue